<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h1 class="mb-5">Neregistruojamų daiktų sutartis</h1>
    <v-card class="pa-5">
      <template>
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(tipas, index) in filterTipasList"
              :key="index"
              cols="12"
              md="2"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  class="mx-auto"
                  @click="checkTipas(toggle, active, tipas)"
                  height="100%"
                  :elevation="active ? '5' : '0'"
                >
                  <el-tipas-icon
                    :icon="tipas.icon"
                    :active="active"
                    type="sutartis"
                  >
                  </el-tipas-icon>
                  <v-card-text>
                    <div :color="active ? 'primary' : 'disabled'">
                      {{ tipas.title }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>
      <template v-if="isTipas">
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(veiksmas, index) in filterVeiksmasList"
              :key="index"
              cols="12"
              md="2"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  class="mx-auto"
                  @click="checkVeiksmas(toggle, active, veiksmas)"
                  height="100%"
                  :elevation="active && isVeiksmas ? '5' : '0'"
                >
                  <el-tipas-icon
                    :icon="veiksmas.icon"
                    :active="active && isVeiksmas"
                    type="sutartis"
                  >
                  </el-tipas-icon>
                  <v-card-text>
                    <div :color="active ? 'primary' : 'disabled'">
                      {{ veiksmas.title }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>

      <template v-if="isVeiksmasContinued || isVeiksmasNew">
        <div class="dataContainer">
          <v-row align="baseline" class="mb-4">
            <template v-if="objektasNerastas">
              <v-col cols="6" md="12">
                <v-alert dense outlined type="error">
                  {{ objektasNerastasMsg }}
                </v-alert>
              </v-col>
            </template>

            <template v-if="isVeiksmasContinued">
              <v-col cols="12" md="8">
                <el-text-field
                  label="Identifikavimo kodas (IDK)"
                  tooltip="Sutartis. Kūrimas. Identifikavimo kodas (IDK)"
                  v-model="searchKodas"
                  idk
                />
              </v-col>
            </template>

            <v-col cols="12" md="12" v-if="isKodas && tipasKitas">
              <v-alert dense outlined type="warning">
                Rastas dokumentas:
                <h4 :class="tipasKitas">{{ sutartisTitle }}</h4>
              </v-alert>
            </v-col>

            <v-col cols="12" md="8">
              <template v-if="hipotekaRole">
                <el-button
                  v-if="isVeiksmasContinued"
                  primary
                  @click.native="checkKodas()"
                  :loading="loadingSearch"
                  :disabled="!canSubmit"
                  >{{ sutartisButtonText }}</el-button
                >
                <el-button
                  v-if="isVeiksmasNew"
                  primary
                  @click.native="sukurtiSutartis()"
                  :loading="loadingSearch"
                  :disabled="!canSubmit"
                  >{{ sutartisButtonText }}</el-button
                >
              </template>
              <template v-if="!hipotekaRole">
                <el-role-negalima class="mt-2" />
              </template>
            </v-col>
          </v-row>
        </div>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
import HipotekaMap from './../hipoteka/hipotekaMap'

export default {
  name: 'Sutartis',
  mixins: [userRole],
  data() {
    return {
      pageloading: true,
      vykdomasis: null,
      veiksmas: null,
      tipas: null,
      objektas: null,
      searchKodas: null,
      tipasKitas: null,
      objektasNerastas: false,
      loadingSearch: false,
      objektasNerastasMsg: null,
      tipasList: [
        {
          key: 'sutartis-atpirkimas',
          type: 'atpirkimas',
          title: 'Pirkimo – pardavimo su atpirkimo teise sutartis',
          icon: 'mdi-account-details-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'sutartis-issimoketinas',
          type: 'issimoketinas',
          title: 'Pirkimo - pardavimo išsimokėtinai sutartis',
          icon: 'mdi-account-cash-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'sutartis-lizingas',
          type: 'lizingas',
          title: 'Lizingo (finansinės nuomos) sutartis',
          icon: 'mdi-account-edit-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'sutartis-nuoma',
          type: 'nuoma',
          title: 'Neregistruojamų daiktų nuomos sutartis',
          icon: 'mdi-account-key-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'sutartis-panauda',
          type: 'panauda',
          title: 'Neregistruojamų daiktų panaudos sutartis',
          icon: 'mdi-account-multiple-check-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
      ],
      veiksmasList: [
        {
          key: 'teikimas',
          type: 'atpirkimas issimoketinas lizingas nuoma panauda new',
          title: 'Teikimas apie sudarytą sutartį',
          icon: 'mdi-file-document-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'pakeitimas',
          type: 'atpirkimas issimoketinas lizingas nuoma panauda continued',
          title: 'Pakeitimas',
          icon: 'mdi-file-document-multiple-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'pabaiga',
          type: 'atpirkimas issimoketinas lizingas nuoma panauda continued',
          title: 'Pabaiga',
          icon: 'mdi-file-remove-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'neisregistruoti',
          type: 'atpirkimas issimoketinas lizingas nuoma panauda continued',
          title: 'Prašymas neišregistruoti sutarties automatiškai',
          icon: 'mdi-file-edit-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'pageidavimas',
          type: 'atpirkimas continued',
          title: 'Pageidavimas pasinaudoti atpirkimo teise',
          icon: 'mdi-file-export-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'atsaukimas',
          type: 'atpirkimas continued',
          title: 'Pageidavimo pasinaudoti atpirkimo teise atšaukimas',
          icon: 'mdi-file-lock-outline',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['objektasID']),

    filterTipasList() {
      return this.tipasList.filter(tipas => {
        return this.roleOr(tipas.role)
      })
    },
    filterVeiksmasList() {
      return this.veiksmasList.filter(veiksmas => {
        return (
          this.roleOr(veiksmas.role) && veiksmas.type.includes(this.tipas.type)
        )
      })
    },
    isVykdomasis() {
      return this.combineType.includes('vykdomasis')
    },
    isVeiksmas() {
      return this.veiksmas !== null
    },
    isTipas() {
      return this.tipas !== null
    },
    isVeiksmasNew() {
      return this.combineType.includes('new')
    },
    isVeiksmasContinued() {
      return this.combineType.includes('continued')
    },
    combineType() {
      let type = ''
      this.tipas && (type += this.tipas.type)
      this.veiksmas && (type += ' ' + this.veiksmas.type)
      this.vykdomasis && (type += ' ' + this.vykdomasis.type)
      return type
    },
    isKodas() {
      return this.objektas && this.objektas.obj_identifikavimo_kodas !== null
    },
    hipotekaTipasMap() {
      return HipotekaMap['hipotekaTipas'][this.hipotekaTipas] ?? []
    },
    sutartisButtonText() {
      return this.hipotekaTipasMap.button
    },
    sutartisTitle() {
      return this.hipotekaTipasMap.title
    },
    hipotekaRole() {
      return this.roleOr(this.hipotekaTipasMap.role)
    },
    hipotekaTipas() {
      return (
        (this.tipas ? this.tipas.key : '') +
        '-' +
        (this.veiksmas ? this.veiksmas.key : '')
      )
    },
    searchTipas() {
      return this.tipasList.filter(tipas => {
        return this.objektas && this.objektas.obj_tipas.includes(tipas.key)
      })[0]
    },
    dokumentasNerastasMsg() {
      return 'Dokumentas nerastas'
    },
    canSubmit() {
      return this.searchKodas || this.isVeiksmasNew
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = false
    },
    checkVykdomasis(toggle, active, vykdomasis) {
      this.vykdomasis = vykdomasis
      this.objektas = null
      this.objektasNerastas = false
      if (!active) {
        toggle()
      }
    },
    checkVeiksmas(toggle, active, veiksmas) {
      this.veiksmas = veiksmas
      this.vykdomasis = null
      this.objektas = null
      this.objektasNerastas = false
      if (!active) {
        toggle()
      }
    },
    checkTipas(toggle, active, tipas) {
      this.tipas = tipas
      this.tipasKitas = null
      this.objektasNerastas = false
      this.vykdomasis = null
      this.veiksmas = null
      this.objektas = null
      if (!active) {
        toggle()
      }
    },
    checkKodas() {
      this.loadingSearch = true
      this.objektas = null
      this.objektasNerastas = false
      this.tipasKitas = null

      const data = {
        obj_tipas: this.hipotekaTipas,
        obj_identifikavimo_kodas: this.searchKodas,
      }
      this.$axios
        .post(`objektas/search`, data)
        .then(res => {
          this.objektas = res.data.objektas

          if (!this.objektas.obj_tipas.includes(this.tipas.key)) {
            if (this.searchTipas) {
              this.tipas = this.searchTipas
              this.tipasKitas = 'tipasKitas'
            } else {
              this.objektasNerastas = true
              this.objektasNerastasMsg = this.dokumentasNerastasMsg
            }
            this.loadingSearch = false
          } else {
            this.sukurtiSutartis()
          }
        })
        .catch(err => {
          this.objektasNerastas = true
          this.objektasNerastasMsg =
            err.response.data.message ?? this.dokumentasNerastasMsg
          this.loadingSearch = false
          // window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    sukurtiSutartis() {
      this.loadingSearch = true
      const data = {
        obj_tipas: this.hipotekaTipas,
        dok_id: this.objektas ? this.objektas.dok_id : null,
        vyk_id: this.objektas ? this.objektas.vyk_id : null,
      }
      this.$axios
        .post(`objektas`, data)
        .then(res => {
          this.$store.dispatch('objektasID', res.data.objektas.obj_id)
          this.$store.dispatch('hipotekaTipas', this.hipotekaTipas)
          this.$store.dispatch('objektasVeiksmas', 0)
          this.$router.push({
            name: 'hipotekaPranesimas',
            params: {
              objektasID: this.objektasID,
            },
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loadingSearch = false
        })
        .finally(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.tipasKitas {
  color: #686868;
}
.dataContainer {
  max-width: 800px;
}
</style>
